import styled from 'styled-components';

import { Props } from './Description';

export const StyledDescription = styled.div<Props>`
  font-weight: 400;
  font-size: 1.6rem;
  line-height: 1.4;
  color: ${({ theme }) => theme.system.black};
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${(props) => props.maxLineCount};
  display: -webkit-box;
  margin-top: 16px;
  height: calc(1.6rem * ${(props) => props.maxLineCount} * 1.4);

  & a {
    word-break: break-all;
  }
`;
